import { render, staticRenderFns } from "./CustomerManagementSuspend.vue?vue&type=template&id=05fda36a&scoped=true&"
import script from "./CustomerManagementSuspend.vue?vue&type=script&lang=js&"
export * from "./CustomerManagementSuspend.vue?vue&type=script&lang=js&"
import style0 from "./CustomerManagementSuspend.vue?vue&type=style&index=0&id=05fda36a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fda36a",
  null
  
)

export default component.exports